export const OPEN = 1;
export const READY_TO_SEND = 2;
export const SENT_TO_ABACUS = 3;
export const PRINTED = 4;
export const PROBLEM_WITH_ABACUS = 5;
export const SENT_VIA_EMAIL = 6;
export const CANCEL = 7;

export default Object.freeze({
  OPEN,
  READY_TO_SEND,
  SENT_TO_ABACUS,
  PRINTED,
  PROBLEM_WITH_ABACUS,
  SENT_VIA_EMAIL,
  CANCEL
});
